import {customElement, query} from 'lit/decorators.js';
import {LitElement} from "lit";
import {SbkSelect} from "@/components/select/select";
import {SbkDatepicker} from "@/components/datepicker/datepicker";

// eslint-disable-next-line
declare const TYPO3: any;

type SelectOption = {
    value: string;
    label: string;
    description?: string;
    selected?: boolean;
};

@customElement('sbk-callback-form')
export class SbkCallbackForm extends LitElement {

    @query('#thema')
    subject!: SbkSelect;

    @query('#erreichbarkeitAm')
    date!: SbkDatepicker;

    @query('#von')
    selectFrom!: SbkSelect;

    @query('#bis')
    selectTo!: SbkSelect;

    protected createRenderRoot() {
        return this
    }

    connectedCallback() {
        super.connectedCallback();
        this.callerForChangeTimeFrom();

        this.subject.addEventListener('select-value-changed', () => {
            this.callerForChangeTimeFrom();
        });
        this.date.addEventListener('datepicker-change', () => {
            this.callerForChangeTimeFrom();
        });
        // this function is called when app finishes access token validation
        // @ts-expect-error tbd
        window.onAppValidatedHcvTokenRueckrufservice = () => {
            this.changeTimeFrom();
        };
    }

    callerForChangeTimeFrom() {
        // check if app or web request
        if ((/.*OGSMobileAppVersion\/[0-9]+.[0-9]+.[0-9]+.*/).test(navigator.userAgent)) {

            let version = '';
            const searchString = "OGSMobileAppVersion/";
            const startIndex = navigator.userAgent.indexOf(searchString);

            if (startIndex !== -1) {
                const endIndex = navigator.userAgent.indexOf(" ", startIndex + searchString.length);
                if (endIndex !== -1) {
                    // space character found
                    version = navigator.userAgent.substring(startIndex + searchString.length, endIndex);
                } else {
                    // no space character found
                    version = navigator.userAgent.substring(startIndex + searchString.length);
                }
            }

            if (version != '') {

                const parts = version.split(".");
                const summeryOfParts = (Number(parts[0]) * 1000000) + (Number(parts[1]) * 10000) + Number(parts[2])

                if (summeryOfParts >= 5000004) {
                    // app request with version greater than 5.0.4 -> call javascript bridge

                    const newBridgeData = '{"validateHcvTokenRueckrufservice":{}}';

                    if (navigator.userAgent.includes("iPhone")) {
                        // @ts-expect-error tbd
                        window.webkit.messageHandlers["AppNotifier"].postMessage(newBridgeData);
                    } else {
                        // @ts-expect-error tbd
                        AppNotifier.postMessage(newBridgeData);
                    }
                } else {
                    // request with old app version
                    this.changeTimeFrom();
                }
            } else {
                // no version found
                this.changeTimeFrom();
            }
        } else {
            // web request
            this.changeTimeFrom();
        }
    }

    changeTimeFrom() {
        if (this.subject.selectedOption?.value && this.date.datepickerValue) {
            // FormValidation.removeErrors(dateField)
            fetch(`/ajax/ogs/callbackTimes?subject=${this.subject.selectedOption?.value}`)
                .then((response) => response.json())
                .then((data) => {
                    const datepickerValue = this.transformDate(this.date.datepickerValue);
                    const selectedDate = new Date(datepickerValue + "T00:00:00")
                    const currentWeekdayIndex = selectedDate.getDay()

                    const selectOption = {
                        value: '',
                        label: TYPO3.lang["ogsPleaseSelect"],
                        selected: false,
                        disabled: true
                    };
                    let choicesTimeFrom: SelectOption[] = [selectOption];
                    let choicesTimeTo: SelectOption[] = [selectOption];

                    const currentWeekDay = data.find(
                        (weekday: { utcWochentag: number; zeitfenster: [{ von: string; bis: string }] }) =>
                            weekday.utcWochentag === currentWeekdayIndex
                    );

                    currentWeekDay?.zeitfenster.forEach((timeWindow: { von: string, bis: string }) => {
                        let startTimeVon = new Date(datepickerValue + "T" + timeWindow.von)
                        if (this.isToday(selectedDate)) {
                            const currentDate = new Date()
                            if (currentDate >= startTimeVon) {
                                startTimeVon = new Date(currentDate.getTime() + 120 * 60000)
                                startTimeVon.setMinutes(Math.ceil(startTimeVon.getMinutes() / 30) * 30);
                            }
                        }
                        let startTimeBis = new Date(startTimeVon.getTime() + 120 * 60000)
                        const endTimeBis = new Date(datepickerValue + "T" + timeWindow.bis)
                        const endTimeVon = new Date(endTimeBis.getTime() - 120 * 60000)
                        const diffMinutes = 30
                        while (startTimeVon <= endTimeVon) {
                            const selectedValue = this.selectFrom.dataset.value ?? '';
                            choicesTimeFrom = [...choicesTimeFrom, this.transformDateToChoice(startTimeVon, selectedValue)]
                            startTimeVon = new Date(startTimeVon.getTime() + diffMinutes * 60000);
                        }
                        while (startTimeBis <= endTimeBis) {
                            const selectedValue = this.selectTo.dataset.value ?? '';
                            choicesTimeTo = [...choicesTimeTo, this.transformDateToChoice(startTimeBis, selectedValue)]
                            startTimeBis = new Date(startTimeBis.getTime() + diffMinutes * 60000);
                        }
                    })

                    if (choicesTimeFrom.length < 2 || choicesTimeTo.length < 2) {
                        this.selectFrom.disabled = true;
                        this.selectTo.disabled = true;
                    }

                    if (choicesTimeTo.length > 1) {
                        this.selectFrom.options = choicesTimeFrom;
                        this.selectFrom.disabled = false;
                        this.selectFrom.addEventListener('select-value-changed', (event: Event) => {
                            if ((event as CustomEvent).detail.value) {
                                const timeFromValue = new Date(datepickerValue + "T" + (event as CustomEvent).detail.value + ":00")
                                this.changeTimeTo(timeFromValue, choicesTimeTo);
                            }
                        });
                    } else {
                        this.selectTo.disabled = true;
                    }
                })
        } else {
            this.selectFrom.disabled = true;
            this.selectTo.disabled = true;
        }
    }

    changeTimeTo(timeFromValue: Date, choicesTimeTo: SelectOption[]) {
        const selectOption = {
            value: '',
            label: TYPO3.lang["ogsPleaseSelect"],
            selected: false,
            disabled: true
        };
        let newChoicesTimeTo: SelectOption[] = [selectOption];
        const startTimeBis = new Date(timeFromValue.getTime() + 120 * 60000)

        choicesTimeTo.forEach((entry) => {
            const compareTime = new Date(startTimeBis.toISOString().split("T")[0] + "T" + entry.value + ":00")
            if (compareTime >= startTimeBis) {
                newChoicesTimeTo = [...newChoicesTimeTo, entry]
            }
        })
        this.selectTo.options = newChoicesTimeTo;
        this.selectTo.disabled = false;
    }

    transformDateToChoice(entry: Date, selectedValue: string) {
        const currentHours = ('0' + entry.getHours()).slice(-2);
        const currentMinutes = ('0' + entry.getMinutes()).slice(-2);
        const time = currentHours + ":" + currentMinutes
        return {
            value: time,
            label: time,
            selected: time === selectedValue,
            disabled: false,
        }
    }

    isToday(date: Date) {
        const today = new Date()
        return date.getDate() == today.getDate() &&
            date.getMonth() == today.getMonth() &&
            date.getFullYear() == today.getFullYear()
    }

    transformDate(date: string): string {
        if (!date) {
            return '';
        }
        const [day, month, year] = date.split('.');
        return `${year}-${month}-${day}`;
    }
}
